/**
 * The meal ideas a grocery list item is on the list for, in the order it was linked to them, each
 * once. Ideas not loaded (or since deleted) are left out.
 *
 * @param {{meal_ideas?: Array<{meal_idea_id: number}>}} item
 * @param {Object<number, {id: number, name: string}>} ideasById
 * @returns {Array<{id: number, name: string}>}
 */
export function ideasOf(item, ideasById) {
	const seen = new Set();
	const ideas = [];
	for(const link of item.meal_ideas || []) {
		const idea = ideasById[link.meal_idea_id];
		if(idea && !seen.has(idea.id)) {
			seen.add(idea.id);
			ideas.push(idea);
		}
	}
	return ideas;
}
